import Slider from './Slider'

export * from './styles'
export * from './types'

export default Slider
